import script from "./Register.vue?vue&type=script&lang=ts&setup=true"
export * from "./Register.vue?vue&type=script&lang=ts&setup=true"

import "./Register.vue?vue&type=style&index=0&id=7af15fbe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af15fbe"]])

export default __exports__